import { type ViewSurface } from '@terros/common'
import { type QueryKey } from '@tanstack/react-query'

export const viewListKey = (surface?: ViewSurface): QueryKey => {
  if (!surface) return ['ViewList']
  return ['ViewList', surface]
}
